<template>
    <ProductsList/>
</template>

<script>
import ProductsList from '../../components/products/ProductsList';

export default {
  components: {
    ProductsList,
  },
};
</script>
